<script>

export default {
  methods: {
    copyToClipboard(id) {
      const value = document.getElementById(id).value
      const el = document.createElement('textarea')
      el.value = value
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$successToast(this.$t('PaymentRedirectPage.valueCopied', { value: value }))
    }
  }
}
</script>
